import { InputHTMLAttributes } from 'react'

import { CustomActionProps, TestIdProps } from 'designSystem/types/propTypes'

import PDSIcon from 'designSystem/components/PDSIcon/PDSIcon'
import PDSIconButton from 'designSystem/components/PDSIconButton/PDSIconButton'
import INTERNALxInput from 'designSystem/components/internal/elements/INTERNALxInput'
import INTERNALxLabel from 'designSystem/components/internal/elements/INTERNALxLabel'
import { COLOR } from 'designSystem/foundations/constants/color'
import { FONT_SIZE } from 'designSystem/foundations/constants/fontSize'
import { SIZE } from 'designSystem/foundations/constants/size'

import INTERNALxDiv from '../internal/elements/INTERNALxDiv'

type SearchBarSize = 'sm' | 'md' | 'lg'

type BaseProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> &
  CustomActionProps &
  TestIdProps

type Props = BaseProps & {
  border?: boolean
  size?: SearchBarSize
}

export default function PDSSearchBar({
  // Replace border with variant if more varieties come
  border = true,
  onClear,
  size = 'md',
  testId,
  value,
  width = '100%',
  ...props
}: Props) {
  const borderStyle = border ? `1px solid ${COLOR.grey400}` : 'none'

  const inputHeight =
    SEARCH_BAR_SIZE[size].inputHeight ?? SEARCH_BAR_SIZE.md.inputHeight
  const fontSize = SEARCH_BAR_SIZE[size].fontSize ?? SEARCH_BAR_SIZE.md.fontSize

  return (
    <INTERNALxLabel
      backgroundColor={COLOR.backdrop}
      border={borderStyle}
      borderRadius={SIZE.s8}
      className="search-bar-container"
      display="block"
      minWidth="10rem"
      testId={testId}
      width={width}
    >
      <INTERNALxDiv
        alignItems="center"
        display="flex"
        gap={SIZE.s8}
        paddingX={SIZE.s12}
      >
        <PDSIcon size="sm" name="search" />
        <INTERNALxInput
          {...props}
          background="none"
          className="search-bar-input"
          color={COLOR.textSecondary}
          testId={`${testId}-input`}
          flex={1}
          fontSize={fontSize}
          minWidth="5rem"
          type="text"
          height={inputHeight}
          value={value}
        />
        {onClear && (
          <PDSIconButton
            className="search-bar-close"
            name="close"
            onClick={() => onClear()}
            size="sm"
            testId={testId && `${testId}-clear`}
          />
        )}
      </INTERNALxDiv>
    </INTERNALxLabel>
  )
}

const SEARCH_BAR_SIZE = {
  sm: { fontSize: FONT_SIZE.fs12, inputHeight: '2.5rem' },
  md: { fontSize: FONT_SIZE.fs14, inputHeight: '2.75rem' },
  lg: { fontSize: FONT_SIZE.fs16, inputHeight: '3rem' },
}
